<template>
  <div id="main-additional-wrapper">
    <div class="select-data-wrapper">
      <div id="chooseEmployee">
        <a-row type="flex">
          <a-col>
            <h2>{{ $t("employee") }}</h2>
          </a-col>
          <a-col style="flex: 1; margin-left: 15px">
            <a-select style="width: 100%; text-align: center" showSearch :filter-option="false" :default-value="
              userInfo[currentUserIdForEdit].LAST_NAME +
              ' ' +
              userInfo[currentUserIdForEdit].NAME
            " :value="
  userInfo[currentUserIdForEdit].LAST_NAME +
  ' ' +
  userInfo[currentUserIdForEdit].NAME
" @search="searchUser" @change="changecurrentUserIdForEdit">
              <a-select-option v-for="( employee ) of filterUserList" :key="employee.ID" :value="employee.ID">
                <a-avatar v-if="employee.PERSONAL_PHOTO" style="width: 24px; height: 24px; margin-bottom: 3px"
                  :src="employee.PERSONAL_PHOTO" />
                <a-avatar v-else style="
                    width: 25px;
                    height: 25px;
                    color: #f56a00;
                    background-color: #fde3cf;
                    margin-bottom: 3px;
                    line-height: 24px;
                    font-weight: 500;
                  ">{{ employee.NAME ? employee.NAME[0] : "?" }}</a-avatar>
                {{ `${employee.LAST_NAME} ${employee.NAME}` }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="history-data-wrapper">
      <a-drawer :title="$t('Archive preview')" width="100%" placement="right" :closable="true" :visible="visiblePreview"
        @close="onClose">
        <a-table :columns="archiveTableColumns" :dataSource="archiveTableData" :pagination="{
          'show-size-changer': true,
          showTotal: (total) => `${this.$t('Total')} ${total}`,
        }" size="middle" :scroll="scrollX" bordered></a-table>
      </a-drawer>

      <a-row type="flex">
        <a-col style="padding-right: 15px">
          <h2 orientation="left">{{ $t("Historia zmian") }}</h2>
        </a-col>
      </a-row>
      <a-row>
        <a-col>
          <a-table :columns="historyColumns" :dataSource="additionalUserData" :pagination="{
            pageSizeOptions: pageSizeOptions,
            showSizeChanger: true,
            pageSize: pageSize,
          }" size="small" bordered></a-table>
        </a-col>
      </a-row>
    </div>
    <div class="archive-data-wrapper">
      <a-row type="flex">
        <a-col>
          <h2>{{ $t("Archiwum") }}</h2>
        </a-col>
        <a-col style="padding-left: 15px">
          <a-input-search :placeholder="$t('archive comment')" :enter-button="$t('Archiwum')" v-model="commentArchive"
            @search="onAddCommentedArchive" />
        </a-col>
      </a-row>
      <a-row>
        <a-col>
          <a-table :columns="archiveColumns" :dataSource="archiveUserData" :pagination="{
            pageSizeOptions: pageSizeOptions,
            showSizeChanger: true,
            pageSize: pageSize,
          }" size="small" bordered>
            <template slot="preview" slot-scope="text, record">
              <a-button @click="previewFile(record)" type="link" icon="eye" />
              <a-button @click="showDeleteConfirm(record)" type="link" icon="delete" style="margin-left: 10px" />
            </template>
          </a-table>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

 <script>
import { updateAuth, generateFormData } from "../requestFunc";
import moment from "moment";
import readXlsxFile from "read-excel-file";
export default {
  props: [
    "userInfo",
    "currentUserIdForEdit",
    "userAccess",
    "additionalUserData",
    "companies",
    "archiveUserData",
    "departments"
  ],
  components: {
    // commonData,
    // closedData,
  },
  data() {
    return {
      visiblePreview: false,
      pageSize: 10,
      pageSizeOptions: ["10", "20", "50", "100"],
      historyColumns: [
        {
          title: this.$t("category"),
          dataIndex: "category",
          key: "category",
          width: 200,
          ellipsis: true,
          align: "center"
        },
        {
          title: this.$t("field"),
          dataIndex: "field",
          key: "field",
          width: 200,
          ellipsis: true,
          align: "center"
        },
        {
          title: this.$t("oldspace"),
          dataIndex: "old",
          align: "center",
          customRender: (text, record) =>
            this.customRenderHistory(text, record, "old")
        },
        {
          title: this.$t("newspace"),
          dataIndex: "new",
          align: "center",
          customRender: (text, record) =>
            this.customRenderHistory(text, record, "new")
        },
        {
          title: this.$t("editdate"),
          dataIndex: "date_change",
          width: 150,
          align: "center"
        },
        {
          title: this.$t("user"),
          dataIndex: "user",
          key: "user",
          align: "center"
        }
      ],
      archiveColumns: [
        {
          title: this.$t("Archivedate"),
          dataIndex: "archivedate",
          key: "archivedate",
          align: "center"
        },
        {
          title: this.$t("Comment"),
          dataIndex: "comment",
          key: "comment",
          align: "center"
        },
        {
          title: this.$t("Preview"),
          dataIndex: "preview",
          key: "preview",
          align: "center",
          scopedSlots: { customRender: "preview" }
        }
      ],
      archiveTableData: [],
      scrollX: { x: 7100 },
      archiveTableColumns: [
        {
          title: "ID",
          dataIndex: "ID",
          width: 50
        },
        {
          title: "Email",
          dataIndex: "EMAIL",
          width: 150,
          customRender: text => {
            if (text) {
              return <a-tag color="blue">{text}</a-tag>;
            }
          }
        },
        {
          title: this.$t("Name"),
          dataIndex: "NAME",
          width: 150
        },
        {
          title: this.$t("Last name"),
          dataIndex: "LAST_NAME",
          width: 150
        },
        {
          title: this.$t("Position"),
          dataIndex: "WORK_POSITION",
          width: 150
        },
        {
          title: this.$t("Department"),
          dataIndex: "UF_DEPARTMENT",
          width: 150
        },
        {
          title: this.$t("UF_PHONE_INNER"),
          dataIndex: "UF_PHONE_INNER",
          width: 150
        },
        {
          title: this.$t("PERSONAL_PHONE"),
          dataIndex: "PERSONAL_PHONE",
          width: 150
        },
        {
          title: this.$t("PERSONAL_MOBILE"),
          dataIndex: "PERSONAL_MOBILE",
          width: 150
        },
        {
          title: this.$t("SECOND_NAME"),
          dataIndex: "SECOND_NAME",
          width: 150
        },
        {
          title: this.$t("PERSONAL_CITY"),
          dataIndex: "PERSONAL_CITY",
          width: 150
        },
        {
          title: this.$t("PERSONAL_BIRTHDAY"),
          dataIndex: "PERSONAL_BIRTHDAY",
          width: 150,
          customRender: text => {
            if (text) {
              return (
                <a-tag color="blue">{`${this.moment(text).format(
                  "YYYY-MM-DD"
                )}`}</a-tag>
              );
            }
            return text;
          }
        },
        {
          title: this.$t("PERSONAL_GENDER"),
          dataIndex: "PERSONAL_GENDER",
          width: 150
        },
        {
          title: this.$t("UF_PHONE_INNER"),
          dataIndex: "UF_PHONE_INNER",
          width: 150
        },
        {
          title: this.$t("StanZatrudnienia"),
          dataIndex: "StanZatrudnienia",
          width: 150
        },
        {
          title: this.$t("TypZatrudnienia"),
          dataIndex: "TypZatrudnienia",
          width: 150
        },
        {
          title: this.$t("NazwaFirmy"),
          dataIndex: "NazwaFirmy",
          width: 150
        },
        {
          title: this.$t("DataZatrudnienia"),
          dataIndex: "DataZatrudnienia",
          width: 150
        },
        {
          title: this.$t("DataZakonczeniaRozwiazania"),
          dataIndex: "DataZakonczeniaRozwiazania",
          width: 150
        },
        {
          title: this.$t("Wynagrodzenie"),
          dataIndex: "Wynagrodzenie",
          width: 150
        },
        {
          title: this.$t("Prowizja"),
          dataIndex: "Prowizja",
          width: 150
        },
        {
          title: this.$t("Premia"),
          dataIndex: "Premia",
          width: 150
        },
        {
          title: this.$t("BadaniaLekarskie"),
          dataIndex: "BadaniaLekarskie",
          width: 150,
          customRender: text => {
            if (Array.isArray(text) && text.length) {
              let res = [];
              for (let i of text) {
                res.push(<a-tag color="blue">{i}</a-tag>);
              }
              return res;
            }
            return text;
          }
        },
        {
          title: this.$t("SzkolenieBHP"),
          dataIndex: "SzkolenieBHP",
          width: 150,
          customRender: text => {
            if (Array.isArray(text) && text.length) {
              let res = [];
              for (let i of text) {
                res.push(<a-tag color="blue">{i}</a-tag>);
              }
              return res;
            }
            return text;
          }
        },
        {
          title: this.$t("WymiarUrlopu"),
          dataIndex: "WymiarUrlopu",
          width: 150,
          customRender: text => {
            if (Array.isArray(text) && text.length) {
              let res = [];
              for (let item of text) {
                res.push(
                  <a-tag color="blue">{`${item.name} - ${item.date}`}</a-tag>
                );
              }
              return res;
            }
            return text;
          }
        },
        {
          title: this.$t("Ekwiwalent"),
          dataIndex: "Ekwiwalent",
          width: 150
        },
        {
          title: this.$t("Student"),
          dataIndex: "Student",
          width: 150
        },
        {
          title: this.$t("Samozatrudnienie"),
          dataIndex: "Samozatrudnienie",
          width: 150
        },
        {
          title: this.$t("LiczbaDni"),
          dataIndex: "LiczbaDostepnychDni",
          width: 150
        },
        {
          title: this.$t("employeeGoalsInformation"),
          dataIndex: "employeeGoalsInformation",
          width: 150,
          customRender: text => {
            if (Array.isArray(text) && text.length) {
              let res = [];
              for (let item of text) {
                res.push(
                  <a-tag color="blue">{`${item.name} - ${this.moment(
                    item.date[0]
                  ).format("YYYY-MM-DD")},${this.moment(item.date[1]).format(
                    "YYYY-MM-DD"
                  )}`}</a-tag>
                );
              }
              return res;
            }
            return text;
          }
        },
        {
          title: this.$t("competenceEmployeeInformation"),
          dataIndex: "competenceEmployeeInformation",
          width: 150,
          customRender: text => {
            if (Array.isArray(text) && text.length) {
              let res = [];
              for (let item of text) {
                res.push(
                  <a-tag color="green">{`${item.name} - ${this.moment(
                    item.date[0]
                  ).format("YYYY-MM-DD")},${this.moment(item.date[1]).format(
                    "YYYY-MM-DD"
                  )}`}</a-tag>
                );
              }
              return res;
            }
            return text;
          }
        },
        {
          title: this.$t("trainingEmployeeInformation"),
          dataIndex: "trainingEmployeeInformation",
          width: 150,
          customRender: text => {
            if (Array.isArray(text) && text.length) {
              let res = [];
              for (let item of text) {
                res.push(
                  <a-tag color="orange">{`${item.name} - ${this.moment(
                    item.date[0]
                  ).format("YYYY-MM-DD")},${this.moment(item.date[1]).format(
                    "YYYY-MM-DD"
                  )}`}</a-tag>
                );
              }
              return res;
            }
            return text;
          }
        },
        {
          title: this.$t("evaluationFormEmployeeInformation"),
          dataIndex: "evaluationFormEmployeeInformation",
          width: 150,
          customRender: text => {
            if (Array.isArray(text) && text.length) {
              let res = [];
              for (let item of text) {
                res.push(
                  <a-tag color="blue">{`${item.name} - ${this.moment(
                    item.date[0]
                  ).format("YYYY-MM-DD")},${this.moment(item.date[1]).format(
                    "YYYY-MM-DD"
                  )}`}</a-tag>
                );
              }
              return res;
            }
            return text;
          }
        },
        {
          title: this.$t("PlanRozwojuPracownika"),
          dataIndex: "PlanRozwojuPracownika",
          width: 150
        },
        {
          title: this.$t("FormaRozwiazania"),
          dataIndex: "FormaRozwiazania",
          width: 150
        },
        {
          title: "PESEL",
          dataIndex: "PESEL",
          width: 150
        },
        {
          title: "NIP",
          dataIndex: "NIP",
          width: 150
        },
        {
          title: this.$t("NrDoc"),
          dataIndex: "NrDoc",
          width: 150
        },
        {
          title: this.$t("Skarbowy"),
          dataIndex: "Skarbowy",
          width: 150
        },
        {
          title: this.$t("Wyksztalcenie"),
          dataIndex: "Wyksztalcenie",
          width: 150
        },
        {
          title: this.$t("usedDays"),
          dataIndex: "usedDays",
          width: 150
        },
        {
          title: this.$t("Absences"),
          dataIndex: "daysAbsence",
          width: 150
        },
        {
          title: this.$t("NazwiskoRodowe"),
          dataIndex: "NazwiskoRodowe",
          width: 150
        },
        {
          title: this.$t("timeOff"),
          dataIndex: "timeOff",
          width: 150
        },
        {
          title: this.$t("useDays"),
          dataIndex: "useDays",
          width: 150
        },
        {
          title: this.$t("waitingConfirmed"),
          dataIndex: "waitingConfirmed",
          width: 150
        },
        {
          title: this.$t("dataZvolnienia"),
          dataIndex: "dataZvolnienia",
          width: 150
        },
        {
          title: this.$t("daysLeft"),
          dataIndex: "daysLeft",
          width: 150
        }
      ],
      commentArchive: "",
      searchUserInput: ""
    };
  },
  computed: {
    filterUserList() {
      return this.userInfo
        .map((el, index) => ({ ...el, index }))
        .filter(el => {
          return (
            (el.LAST_NAME + " " + el.NAME)
              .toLowerCase()
              .indexOf(this.searchUserInput.toLowerCase()) > -1
          );
        });
    }
  },
  methods: {
    moment,
    showDeleteConfirm(record) {
      let a = this.archiveUserData.filter(el => {
        console.log(el.key);
        return +el.key != +record.key;
      });
      let func = this.deleteArchive;

      this.$confirm({
        title: "Delete",
        content: "Are you sure delete this task?",
        okText: "Yes",
        okType: "danger",
        cancelText: "No",

        async onOk() {
          let url = "/php/request.php";
          const response = await fetch(url, {
            method: "POST",
            body: generateFormData({
              token: updateAuth().token,
              domain: updateAuth().domain,
              run: "handleDeleteArchiveData",
              id: record.key
            })
          });
          const result = await response.json();
          console.log(result);
          // if (result.status == "success") {
          console.log("record key ", record.key);
          // this.deleteArchive(a);
          func(a);
          // this.archiveUserData = a;
          console.log("ok");
          // }
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    },
    deleteArchive(a) {
      console.log("DDDDDDDDDDDDDDDDDDDDDDDDDDDDD");
      this.$emit("deletearchivefield", a);
    },
    async onAddCommentedArchive() {
      if (this.commentArchive !== "") {
        let url = "/php/request.php";
        const response = await fetch(url, {
          method: "POST",
          body: generateFormData({
            token: updateAuth().token,
            domain: updateAuth().domain,
            run: "handleArchiveData",
            comment: this.commentArchive
          })
        });
        this.commentArchive = "";
        const result = await response.json();
        let result_data = result.data;
        let obj = {
          key: result_data[result_data.length - 1].PROPERTY_VALUES.fileID,
          archivedate:
            result_data[result_data.length - 1].PROPERTY_VALUES.backupDate,
          comment: result_data[result_data.length - 1].PROPERTY_VALUES.comment
        };
        this.$emit("addarchivefield", obj);
      } else {
        this.$message.warning(this.$t("This is a warning comment"));
      }
    },
    customRenderHistory(text, record, type) {
      console.log(text, 'text')
      let value =
        text && (text[0] == "[" || text[0] == "{") ? JSON.parse(text) : text;
      if (!value) return "";
      let result = (
        <a-tag color={type == "new" ? "green" : "orange"}>{this.$t(value)}</a-tag>
      );
      if (Array.isArray(value) && value.length) {
        let keys = Object.keys(value[0]);
        result = [];
        for (let i in value) {
          if (
            record.type_change == "BadaniaLekarskie" ||
            record.type_change == "SzkolenieBHP"
          ) {
            if (Array.isArray(value)) {
              result.push(
                <a-tag color={type == "new" ? "green" : "orange"}>
                  {this.$t(value[i])}
                </a-tag>
              );
            }
          }
          if (record.type_change == "UF_DEPARTMENT") {
            if (this.departments) {
              let dep = this.departments.find(x => x.ID == value[i]);
              if (dep) {
                result.push(
                  <a-tag color={type == "new" ? "green" : "orange"}>
                    {this.$t(dep.NAME)}
                  </a-tag>
                );
              }
            }
          }
          if (
            record.type_change == "additionalEmployeeInformation" &&
            value[i].status
          ) {
            result.push(
              <a-tag color={type == "new" ? "purple" : "orange"}>
                {this.$t(value[i].name)}
              </a-tag>
            );
          } else {
            if (
              keys.includes("name") &&
              value[i].name &&
              record.type_change != "additionalEmployeeInformation"
            ) {
              result.push(
                <a-tag color={type == "new" ? "purple" : "orange"}>
                  {this.$t(value[i].name)}
                </a-tag>
              );
            }
            if (keys.includes("date")) {
              if (Array.isArray(value[i].date)) {
                value[i].date.forEach(val => {
                  if (val)
                    result.push(
                      <a-tag color={type == "new" ? "green" : "orange"}>
                        {this.$t(val)}
                      </a-tag>
                    );
                  // {this.moment(val).format("YYYY-MM-DD")}
                });
              } else if (value[i]) {
                result.push(
                  <a-tag color={type == "new" ? "green" : "orange"}>
                    {value[i].date}
                  </a-tag>
                );
              }
            }
          }
        }
      } else if (record.type_change == "NazwaFirmy") {
        result = this.companies[value] ? (
          <a-tag color={type == "new" ? "green" : "orange"}>
            {this.$t(this.companies[value].TITLE)}
          </a-tag>
        ) : (
          value
        );
      }
      return result;
    },
    onClose() {
      this.visiblePreview = false;
    },
    async previewFile(record) {
      let url = "/php/request.php";
      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "showArchiveDataByID",
          id: record.key
        })
      });
      if (response.ok) {
        const result = await response.json();
        this.downloadArchiveFile(result.link);
      }
      this.visiblePreview = true;
    },
    searchUser(value) {
      this.searchUserInput = value;
    },
    changecurrentUserIdForEdit(index) {
      let key = this.userInfo.findIndex(el => el.ID == index);
      this.$emit("changecurrentUserIdForEdit", key);
      this.$emit("loadSelectedAdditionalData", 4);
    },
    downloadArchiveFile(url) {
      var xhttp = new XMLHttpRequest();
      xhttp.open("GET", url, true);
      xhttp.send();
      xhttp.responseType = "blob";
      xhttp.onload = () => {
        let file = new File([xhttp.response], "archive");
        readXlsxFile(file).then(rows => {
          let keys = rows[0];
          this.archiveTableData = [];
          for (let i = 1; i < rows.length; i++) {
            let obj = {};
            for (let j in keys) {
              if (
                rows[i][j] &&
                typeof rows[i][j] == "string" &&
                rows[i][j][0] == "["
              ) {
                obj[keys[j]] = JSON.parse(rows[i][j]);
              } else {
                obj[keys[j]] = rows[i][j];
              }
            }
            this.archiveTableData.push(obj);
          }
          this.$emit("resize");
        });
      };
    }
  },
  mounted() {
    this.$emit("resize");
  }
};
</script>

<style scoped>
.headerListData .ant-list-item-meta {
  padding: 5px;
}

.headerListData .ant-list-item-meta-content {
  text-align: left;
  margin: auto;
}

.headerListData .ant-list-item-meta-description {
  color: white;
}

.itemsInfo,
.itemsInfoTitle {
  display: block;
  width: 50%;
  text-align: left;
  padding-left: 5px;
  margin: 0;
  line-height: 2.3;
}

.itemsInfo {
  border-left: 1px solid lightgray;
}

.itemsInfo h2 {
  margin: 0;
}

.headerListData .ant-list-item {
  border-radius: 4px 4px 0 0;
  background-color: #0083dc;
  padding-left: 5px;
}

#commonData .ant-list-item,
#personalData .ant-list-item,
#contactData .ant-list-item {
  padding: 0;
}

#contactData,
#commonData {
  margin-bottom: 10px;
}

#main-additional-wrapper {
  font-weight: 200;
  color: #000;
}

#main-additional-wrapper .ant-table-content th,
#main-additional-wrapper .archive-data-wrapper {
  font-weight: 400;
  color: #000;
}

#main-additional-wrapper h2 {
  font-weight: 500;
  color: #000;
}
</style>
